/**
 * Brand API
 *
 * @author minkyoung.park@emcast.com
*/

import httpService from '@/api/httpService'

const brandApi = {
    // 브랜드 담당자 정보 불러오기(Get brand manager information)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest.html#resources-guest-brand-manager
    brandManager(params) {
        return httpService.get(`/guest/${BRAND_CODE}/brand/manager`)
    },

    // 브랜드 정보 불러오기(Get brand information)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest.html#resources-guest-brand-single
    brandInfo(params) {
        return httpService.get(`/guest/${BRAND_CODE}/brand`)
    },
    
    // 브랜드 설정 정보 조회
    getBrandProperties(params) {
       return httpService.get('/brand/properties', params);
   },
}

export default brandApi